import {AdminRole, ROOT} from './../middleware/roles'
import UnloadingOverview from '../../views/unloading/UnloadingOverview'
import UnloadingCargosProductsOnly from '../../views/teamlead/UnloadingCargosProductOnly'
import UnloadingCargos from '../../views/teamlead/UnloadingCargos'
import UnloadingCargo from '../../views/teamlead/UnloadingCargo'
import TeamleadSenderOverview from '../../views/teamlead/SenderOverview'
import OrderDetail from './../../views/teamlead/OrderDetail'
import UnloadingManual from './../../views/teamlead/manualUnloading'
import orderHandling from "../../views/teamlead/orderHandling";
import DockSuggestions from "../../views/teamlead/DockSuggestions";
import deviations from "../../views/teamlead/Deviations";
import orderHandlingTvat from "../../views/teamlead/orderHandlingTvat";

const loadingRoutes = [
  {path: '/unloading', name: 'unloaded', component: UnloadingOverview},
  {
    path: '/unloading/admin/cargos',
    name: 'teamlead-cargos-unloading',
    // component: UnloadingCargosProductsOnly,
    component: UnloadingCargos,
    // meta: {hasAcces: ['teamlead']}
  },
  {
    path: '/unloading/admin/cargos/:cargoId/products',
    name: 'unloading-cargo-products',
    // component: UnloadingCargosProductsOnly,
    component: UnloadingCargosProductsOnly,
    // meta: {hasAcces: ['teamlead']}
  },
  {
    path: '/unloading/view/cargo/:cargoId/order/:orderId',
    name: 'teamlead-view-order-unloading',
    component: OrderDetail,
    props: true
    // meta: {hasAcces: ['teamlead']}
  },
  {
    path: '/unloading/admin/cargos/:id',
    name: 'teamlead-cargo-unloading',
    component: UnloadingCargo,
    props: true
    // meta: {hasAcces: ['teamlead']}
  },
  {
    path: '/unloading/admin/docksuggestions',
    name: 'teamlead-dock-suggestions-unloading',
    component: DockSuggestions,
    meta: { view: 'loading' }
  },
  {
    path: '/unloading/admin/orderhandling',
    name: 'teamlead-order-handling-unloading',
    component: orderHandling,
    meta: { view: 'unloading' }
  },
  {
    path: '/unloading/admin/cargohandling',
    name: 'teamlead-cargo-handling-unloading',
    component: orderHandlingTvat,
    meta: { view: 'unloading' }
  },
  {
    path: '/unloading/admin/deviations',
    name: 'teamlead-deviations-unloading',
    component: deviations
  },
  {
    path: '/unloading/admin/senders',
    name: 'teamlead-unloading-sender-overview',
    component: TeamleadSenderOverview,
    props: true
    // meta: {hasAcces: ['teamlead']}
  },
  {
    path: '/unloading/manual',
    name: 'teamlead-unloading-manual',
    component: UnloadingManual,
    props: true
    // meta: {hasAcces: ['teamlead']}
  },
  // {
  //   path: '/unloading/admin/senders/:id',
  //   name: 'teamlead-cargo-unloading',
  //   component: UnloadingCargo,
  //   props: true
  //   // meta: {hasAcces: ['teamlead']}
  // },
]
export default loadingRoutes

